module.exports = __webpack_public_path__ + "img/cb-statement.830e2b3.webp";